import scroll2AddClass from './module/scroll2AddClass';

window.addEventListener('DOMContentLoaded', function(e) {
  const html = document.querySelector('html');
  const item1 = document.querySelector('.js-top-slide1');
  const item2 = document.querySelector('.js-top-slide2');
  const newsbody = document.querySelector('.js-newsbody');
  const videBtn = document.querySelector('#js-video-btn');
  const video = document.querySelector('#js-video');

  if(location.hash) {
    html.classList.remove('is-stay');
    scroll2AddClass();
  }

  videBtn.addEventListener('click', function() {
    videBtn.style.display = 'none';
    video.play();
  })

  item1.addEventListener('transitionend', function() {
    newsbody.classList.remove('u-hide');
    if(!location.hash) {
      html.classList.remove('is-stay');
      scroll2AddClass();
    }
  })
  item2.addEventListener('transitionend', function() {
    item1.classList.add('is-slideup');
  })
  setTimeout(function() {
    item2.classList.add('is-slideup');
  },1000)
})

window.addEventListener('load', function(e) {
})
